firebird.directive('loadingPopup', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'loading-popup.html'),
            link: function (scope, element) {}
        };
    }
]);
